import DrawerItem from './DrawerItem'
export const items = [
  {
    key: 'userInfo',
    title: 'Home.drawer.userInfo',
    to: '/home/userInfo'
  },
  {
    key: 'screenplayManage',
    title: 'Home.drawer.screenplayManage',
    to: '/home/screenplays'
  }
]
export default items
